<app-licenses-license-info-card [license]="license" [centers]="centers" [applications]="applications"></app-licenses-license-info-card>
